// extracted by mini-css-extract-plugin
export var container = "layout-module--container--eLBMS";
export var heading = "layout-module--heading--8VjLO";
export var navLinks = "layout-module--nav-links--EROwB";
export var navLinkItem = "layout-module--nav-link-item--pfCo2";
export var navLinkText = "layout-module--nav-link-text--ac2nV";